import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import HomeDetailHeader from './HomeDetailHeader';
import HomeDetailPage from './HomeDetailPage';

function HomeDetail({ home, homes, widget }) {
  return (
    <PageWrapper>
      <PageHelmet home={home} />
      <HomeDetailHeader />
      <HomeDetailPage
        home={home}
        homes={homes}
        widget={widget}
      />
    </PageWrapper>
  );
}

HomeDetail.propTypes = {
  home: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  widget: PropTypes.object.isRequired,
};

HomeDetail.defaultProps = {
  community: undefined,
  homes: [],
};

export default withData(
  {
    home: true,
    homes: true,
    widget: 'default_image',
  },
  {
    required: {
      home: true,
    },
    ifMissing404: true,
  },
)(HomeDetail);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/index.js